import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { COLOR } from '../../../common/constant';
import * as Icon from 'ubs-icons';
import UButton from "../../../UButton";

const OtherFile = memo((props) => {
    return (
        <div className="u_m-auto u_text-center u_color-white">
            <Icon.FilePreview fill={COLOR.u_white} size={48} />
            <p className="u_font u_my-10">{props?.file?.fileName}</p>
            <UButton variant="blue" type="Download" onClick={props?.onDownload} cn="u_mt-30"/>
        </div>
    );
});

OtherFile.propTypes = {
  file: PropTypes.object,
  onDownload: PropTypes.func,
};

export default OtherFile; 